import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB9QKZXs46C2f-KBcKHn39tkZCCmpNANLA",
  authDomain: "duomila-webapp2.firebaseapp.com",
  projectId: "duomila-webapp2",
  storageBucket: "duomila-webapp2.firebasestorage.app",
  messagingSenderId: "879826317756",
  appId: "1:879826317756:web:04364998a1d53b6cfe3bb9",
};

const RECAPTCHA_SITE_KEY = "6LfJu94sAAAAAMKrEewlSMNg06QFIpR2T4UDjjT-";

const isDev = process.env.NODE_ENV === "development";

if (isDev && typeof window !== "undefined") {
  // eslint-disable-next-line no-restricted-globals
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

export const firebaseApp = initializeApp(firebaseConfig);

let _appCheck = null;
try {
  _appCheck = initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
} catch (e) {
  // initializeAppCheck può fallire in dev se i domini reCAPTCHA non includono
  // localhost. Non blocchiamo l'app: in dev l'emulator skippa App Check.
  console.warn("[App Check] init failed, continuing without token:", e?.message);
}

export const appCheck = _appCheck;

export const db = getFirestore(firebaseApp);
